import { Dayjs } from 'dayjs';
export interface UpdateConfigRequest {
  key: string;
  value: string;
}

export interface ConfigResponse {
  'days-to-disable-account-after-result-release': string;
  'days-to-expire-password-if-new-account-no-login': string;
  'days-to-email-admin-to-view-after-account-disabled': string;
  'days-to-invalidate-result-release-link-after-generating': string;
  'times-of-max-login-try': string;
  'minutes-of-inactivity-before-session-timeout': string;
  'minutes-of-inactivity-before-session-timeout-privileged-admin': string;
  'minutes-of-inactivity-before-session-timeout-non-privileged-admin': string;
  'days-before-payment-unique-link-expire': string;
  'days-before-access-link-expire': string;
  'months-to-retrieve-transaction-log': string;
}

export interface ConfigurationType {
  code: string;
  description: string;
}

export interface ConfigurationExamRequest {
  q: string;
}

export interface ConfigurationExamResponse {
  code: string;
  description: string;
}

export interface OpenPeriodConfigRequest {
  configurationType: string;
  examLevelCode?: string;
}

export interface OpenPeriodConfigResponse {
  configurationType?: string;
  examLevelCode?: string;
  startDateTime: string;
  endDateTime: string;
  lastUpdatedBy: string;
  lastUpdatedAt: string;
}

export interface CheckWindowPeriod {
  configurationType: string;
  examLevelCode: string;
}

export enum ApplicationType {
  RESIT = 'RESIT',
  EXAM = 'EXAM',
  GROUP_EXAM = 'GROUP_EXAM',
  AMENDMENT = 'AMENDMENT',
  APPEAL = 'APPEAL',
  ACCESS_ARRANGEMENT = 'ACCESS_ARRANGEMENT',
  // Used only for file upload config lookup. Never stored in DB application_type column.
  ACCESS_ARRANGEMENT_INDV_REPORT = 'ACCESS_ARRANGEMENT_INDV_REPORT',
  SPECIAL_CONSIDERATION = 'SPECIAL_CONSIDERATION',
  NON_NATIONAL_EXAM = 'NON_NATIONAL_EXAM',
  ANNOUNCEMENT = 'ANNOUNCEMENT',
}

export enum UploadDocumentType {
  PASSPORT_PHOTO = 'PASSPORT_PHOTO',
  SUPP_DOC = 'SUPP_DOC',
}

export enum NonNationalExamType {
  AEIS = 'AEIS',
  SAEIS = 'SAEIS',
  SPE = 'SPE',
  SPERS = 'SPERS',
}

export enum AttachedFileType {
  DOCUMENT = 'DOCUMENT',
  APPLICATION_FILE = 'APPLICATION_FILE',
}
